import {
  ModifierQuery,
  ModifierQueryEmptyState,
  ModifierQueryProvider,
  ModifiersList,
  useModifierQuery,
} from '@airship-platform/airship-proposal';
import { FlexBox } from '@airship-platform/jam-web/components';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import React from 'react';
import { Link } from 'react-router';
import { useAppointmentProposalOptions } from '../../data-access/appointmentProposalOptions';
import QuickAddModifierButton from '../modifier-query/QuickAddModifierButton';

const ModifierQueryContent: React.FC = () => {
  const { currentOption } = useAppointmentProposalOptions();
  const { searchTerm, rebatesFiltered } = useModifierQuery();

  const rebatesWithActions = rebatesFiltered.map((rebate) => ({
    ...rebate,
    actions: (
      <FlexBox alignItems={'center'} gap={1.5}>
        <Button
          component={Link}
          to={rebate.discountsAndFeesId}
          color="softGold"
          sx={{
            width: ['100%', 'auto'],
            textTransform: 'none',
          }}
        >
          Add item
        </Button>
        <QuickAddModifierButton
          modifier={rebate}
          option={currentOption}
          color="softGold"
        />
      </FlexBox>
    ),
  }));

  return (
    <FlexBox flexDirection={'column'} gap={2}>
      <Typography variant="h2" sx={{ flex: 1 }}>
        Rebates
      </Typography>
      <ModifierQuery>
        <ModifierQueryEmptyState
          searchTerm={searchTerm}
          isVisible={!rebatesFiltered.length}
        />
        <Typography variant="body2">
          {rebatesWithActions.length} results found
        </Typography>
        <ModifiersList availableRebates={rebatesWithActions} />
      </ModifierQuery>
    </FlexBox>
  );
};

const ModifierQueryPage: React.FC = () => (
  <ModifierQueryProvider>
    <ModifierQueryContent />
  </ModifierQueryProvider>
);

export default ModifierQueryPage;
